<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('locationVisitation.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('locationVisitation.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item key="1" @click="() => (copy_form = true)">
                  <a-icon type="copy" />{{ $t('copy') }}</a-menu-item
                >
                <a-menu-item key="2" @click="() => (import_plan = true)">
                  <a-icon type="import" />{{ $t('import') }}</a-menu-item
                >
              </a-menu>
              <a-button style="margin-left: 8px">
                {{ $t('more') }} <a-icon type="down" />
              </a-button>
            </a-dropdown>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3">
            <a-radio-group v-model="visitStatus">
              <a-radio-button value="">
                {{ $t('locationVisitation.all') }}
              </a-radio-button>
              <a-radio-button :value="1">
                {{ $t('locationVisitation.completed') }}
              </a-radio-button>
              <a-radio-button :value="0">
                {{ $t('locationVisitation.incomplete') }}
              </a-radio-button>
            </a-radio-group>
            <a-select
              v-model="provinceCode"
              style="width:300px"
              :options="
                allProvinces.map(el => ({
                  value: el.province_code,
                  label: el.name_en
                }))
              "
              :placeholder="$t('locationVisitation.province')"
              :allowClear="true"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              @change="fetchData()"
            ></a-select>
            <ts-input
              v-model="search"
              v-tooltip="$t('locationVisitation.search')"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <!-- <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('customerProfile.branchName') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter> -->
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td>{{ record.plan_date }}</td>
            <td>{{ record.user.name }}</td>
            <td class="ts-text-center ts-w-6">
              <span class="badge badge-success">{{
                record.commune_list_count
              }}</span>
            </td>
            <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.visit_status"
                >Completed</span
              >
              <span class="badge badge-danger" v-else>Incomplete</span>
            </td>
            <td class="text-center ts-space-x-3">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-11/12 ts-mx-auto">
              <thead>
                <tr>
                  <th>{{ $t('locationVisitation.province') }}</th>
                  <th>{{ $t('locationVisitation.district') }}</th>
                  <th>{{ $t('locationVisitation.commune') }}</th>
                  <th class="ts-text-center">
                    {{ $t('locationVisitation.arrivalTime') }}
                  </th>
                  <th class="ts-text-center">
                    {{ $t('locationVisitation.durationInMinute') }}
                  </th>
                  <th class="ts-text-center">
                    {{ $t('locationVisitation.actualTimeCheckIn') }}
                  </th>
                  <th class="ts-text-center">
                    {{ $t('locationVisitation.actualTimeCheckOut') }}
                  </th>
                  <th class="ts-text-center">
                    {{ $t('locationVisitation.workingHours') }}
                  </th>
                  <th class="ts-text-center">
                    {{ $t('locationVisitation.status') }}
                  </th>
                  <th class="ts-text-center">
                    {{ $t('locationVisitation.map') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in prop.record.commune_list"
                  :key="index"
                >
                  <td>{{ item.province_name_en }}</td>
                  <td>{{ item.district_name_en }}</td>
                  <td>{{ item.commune_name_en }}</td>
                  <td class="ts-text-center">
                    {{ moment(item.arrival_time, 'HH:mm:ss').format('h:mm A') }}
                  </td>
                  <td class="ts-text-center">{{ item.duration_in_minute }}</td>
                  <td class="ts-text-center">
                    {{
                      item.check_in_time
                        ? moment(item.check_in_time, 'HH:mm:ss').format(
                            'h:mm A'
                          )
                        : ''
                    }}
                  </td>
                  <td class="ts-text-center">
                    {{
                      item.check_out_time
                        ? moment(item.check_out_time, 'HH:mm:ss').format(
                            'h:mm A'
                          )
                        : ''
                    }}
                  </td>
                  <td class="ts-text-center">
                    {{ item.actual_duration_in_minute }} min
                  </td>
                  <td class="ts-text-center">{{ item.visitation_status }}</td>
                  <td>
                    <a href="#" 
                      class="text-green"
                      v-tooltip="$t('locationVisitation.map')"
                      @click.prevent="viewMap(item)"
                    ><i class="fas fa-map"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('locationVisitation.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        :maskClosable="false"
        width="1300px"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>

      <a-modal
        :title="$t('copy')"
        :visible="copy_form"
        @cancel="() => (copy_form = false)"
        @ok="onCopy"
        :confirmLoading="waiting"
        width="300px"
      >
        <div class="row">
          <div class="col-md-6">
            <label class="required ts-uppercase">{{ $t('from') }}</label>
            <a-month-picker
              v-model="model.date_from"
              format="MM-YYYY"
              valueFormat="MM-YYYY"
              class="ts-full"
            />
            <div class="validate ts-text-xs" v-if="errors.has('date_from')">
              {{ errors.first('date_from') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="required ts-uppercase">{{ $t('to') }}</label>
            <a-month-picker
              v-model="model.date_to"
              format="MM-YYYY"
              valueFormat="MM-YYYY"
              class="ts-full"
            />
            <div class="validate ts-text-xs" v-if="errors.has('date_to')">
              {{ errors.first('date_to') }}
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal
        :title="$t('import')"
        v-if="import_plan"
        :visible="import_plan"
        @cancel="() => (import_plan = false)"
        width="300px"
        :footer="null"
        :maskClosable="false"
        :centered="true"
      >
        <ImportPlane @cancel="onImportCancel" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import FromAction from './form'
import ImportPlane from './importPlane.vue'
import moment from 'moment'
import { Errors } from 'form-backend-validation'

export default {
  name: 'locationVisitationIndex',
  components: {
    FromAction,
    ImportPlane
  },
  data() {
    return {
      loading: false,
      showForm: false,
      waiting: false,
      copy_form: false,
      import_plan: false,
      errors: new Errors(),
      model: {
        date_from: moment()
          .add(-1, 'month')
          .format('MM-YYYY'),
        date_to: moment().format('MM-YYYY')
      }
    }
  },
  computed: {
    ...mapState('customer/locationVisitation', [
      'resources',
      'pagination',
      'allProvinces'
    ]),
    search: {
      get() {
        return this.$store.state.customer.locationVisitation.search
      },
      set(newValue) {
        this.$store.commit('customer/locationVisitation/SET_SEARCH', newValue)
        this.$store.commit('customer/locationVisitation/RESET_CURRENT_PAGE')
      }
    },
    provinceCode: {
      get() {
        return this.$store.state.customer.locationVisitation.province_code
      },
      set(newValue) {
        this.$store.commit(
          'customer/locationVisitation/SET_PROVINCE_CODE',
          newValue
        )
      }
    },
    visitStatus: {
      get() {
        return this.$store.state.customer.locationVisitation.visitStatus
      },
      set(newValue) {
        this.$store.commit(
          'customer/locationVisitation/SET_VISIT_STATUS',
          newValue
        )
      }
    },
    columns() {
      return [
        { name: this.$t('locationVisitation.date') },
        { name: this.$t('locationVisitation.saleName') },
        { name: this.$t('locationVisitation.totalCommune') },
        {
          name: this.$t('locationVisitation.status'),
          style: 'text-align:center;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    },
    dateRange: {
      get() {
        return this.$store.state.customer.locationVisitation.dateRange
      },
      set(newValue) {
        this.$store.commit(
          'customer/locationVisitation/SET_DATE_RANGE',
          newValue
        )
      }
    }
  },
  methods: {
    ...mapActions('customer/locationVisitation', ['getProvince']),
    moment,
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('customer/locationVisitation/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('customer/locationVisitation/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('customer/locationVisitation/SET_EDIT_DATA', {})
      this.$store.commit('customer/locationVisitation/CLEAR_RESOURCE_SETUP')
      this.showForm = false
      this.fetchData()
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('customer/locationVisitation/destroy', record.plan_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    onCopy() {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch('customer/locationVisitation/copy', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.copy_form = false
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onImportCancel(){
      this.import_plan = false
      this.fetchData()
    },
    viewMap(record) {
      let routeData = this.$router.resolve({
        name: 'location-visitation-view-map',
        params: {
          commune_code: record.commune_code,
          plan_id: record.plan_id
        } 
      });
      window.open(routeData.href, '_blank');
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500),
    visitStatus: debounce(function() {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
      vm.getProvince()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('customer/locationVisitation/RESET_STATE')
    next()
  }
}
</script>
